/** FMX marketing's Google Tag Manager container (from the web team). */
export const GRANTS_EMBED_GTM_ID = 'GTM-P63RP3Q';

/** Query params that carry personal data and must never reach analytics. */
const PII_PARAMS = ['email'];

/**
 * The page URL with personal-data params removed, or null if there were none. Marketing links may
 * carry the visitor's email; GTM/GA record the page URL, and Google's terms forbid sending PII
 * there — so it's stripped before any tag loads.
 */
export function urlWithoutPii(href: string): string | null {
  const url = new URL(href);
  if (!PII_PARAMS.some((p) => url.searchParams.has(p))) return null;
  for (const p of PII_PARAMS) url.searchParams.delete(p);
  return url.toString();
}

/** Production only, so staging/preview testing never pollutes marketing's analytics. */
export function gtmIdForEnv(vercelEnv: string | undefined): string | null {
  return vercelEnv === 'production' ? GRANTS_EMBED_GTM_ID : null;
}

/** dataLayer events marketing's GTM container can trigger on. These never carry PII. */
export const GRANTS_EVENT = {
  leadCaptured: 'fmx_grants_lead_captured',
} as const;

export function pushGrantsEvent(event: (typeof GRANTS_EVENT)[keyof typeof GRANTS_EVENT], data: Record<string, number | string>) {
  pushDataLayer({ event, ...data });
}

/**
 * Marketing's standard gated-content conversion, in the shape their GTM container already handles
 * for gofmx.com downloads. Unlike GRANTS_EVENT it carries the visitor's email, at marketing's
 * request — their GTM tags decide where it goes.
 */
export function pushGatedCollateralRequest({
  firstName,
  lastName,
  company,
  email,
}: {
  firstName: string;
  lastName: string;
  company: string;
  email: string;
}) {
  pushDataLayer({
    event: 'gated-collateral-request',
    eventLabel: 'K-12 Grant Finder',
    eventCategory: 'report',
    contactFirstName: firstName,
    contactLastName: lastName,
    contactCompany: company,
    contactEmail: email,
    contactIndustry: 'K-12',
  });
}

function pushDataLayer(entry: Record<string, unknown>) {
  const w = window as unknown as { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(entry);
}
